import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function GrowthAnalyticsTab() {
  const [stats, setStats] = useState({ referrals: 0, qualified: 0, redemptions: 0, subscribers: 0, codes: 0 });

  useEffect(() => {
    (async () => {
      const [r, q, red, subs, codes] = await Promise.all([
        supabase.from("referrals").select("id", { count: "exact", head: true }),
        supabase.from("referrals").select("id", { count: "exact", head: true }).eq("status", "qualified"),
        supabase.from("promo_redemptions").select("id", { count: "exact", head: true }),
        supabase.from("newsletter_subscribers").select("id", { count: "exact", head: true }).eq("is_active", true),
        supabase.from("referral_codes").select("id", { count: "exact", head: true }),
      ]);
      setStats({
        referrals: r.count ?? 0,
        qualified: q.count ?? 0,
        redemptions: red.count ?? 0,
        subscribers: subs.count ?? 0,
        codes: codes.count ?? 0,
      });
    })();
  }, []);

  const items = [
    { label: "Total Referrals", value: stats.referrals },
    { label: "Qualified Referrals", value: stats.qualified },
    { label: "Promo Redemptions", value: stats.redemptions },
    { label: "Newsletter Subscribers", value: stats.subscribers },
    { label: "Referral Codes Issued", value: stats.codes },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
      {items.map(i => (
        <Card key={i.label}>
          <CardHeader className="pb-2"><CardTitle className="text-sm text-muted-foreground">{i.label}</CardTitle></CardHeader>
          <CardContent><div className="text-3xl font-bold">{i.value}</div></CardContent>
        </Card>
      ))}
    </div>
  );
}
